// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaDetailsBase, CriteriaDetailsBaseSchema } from 'api/gen/CriteriaDetailsBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { IntegerCriteriaValues, IntegerCriteriaValuesSchema } from 'api/gen/IntegerCriteriaValues';

const requiredPart = t.interface({
  tag: t.literal('INT'),
  values: IntegerCriteriaValuesSchema,
});

export const IntegerCriteriaDetailsSchema = excess(t.intersection([CriteriaDetailsBaseSchema.type, requiredPart]));

export interface IntegerCriteriaDetails extends t.TypeOf<typeof IntegerCriteriaDetailsSchema> {}
